const validVersionRegex = new RegExp('^([0-9]+\\.){2}[0-9]+$'); // Expected format is "n.n.n" where "n" is an int number
const getMobileOsParam = osName => (osName === 'android' || osName === 'ios' ? `osname=${osName}` : '');
const getMobileOsVersionParam = osVersion => (validVersionRegex.test(osVersion) ? `osversion=${osVersion}` : '');

module.exports = {
  getMobileOsParam,
  getMobileOsVersionParam,
};
